import React from 'react'
import { Card, type CardProps } from '@mantine/core'

export type AppCardProps = CardProps

function AppCardRoot ({
  withBorder = true,
  radius = 'md',
  padding = 'md',
  ...props
}: AppCardProps) {
  return <Card withBorder={withBorder} radius={radius} padding={padding} {...props} />
}

/** Standard card container with border and consistent padding. */
const AppCard = Object.assign(AppCardRoot, {
  Section: Card.Section
})

export default AppCard
